import { Icon } from "../ui/Icon";

/**
 * Evrak kartı — görsel önizleme / PDF ikonu. Tıklayınca onOpen(url) ile lightbox modal açılır
 * (yeni sekme YOK). Düzenlenebilirse × ile kaldırılır. Tüm kullanımda 116px sabit genişlik → tek-tip ızgara.
 * `isPdf` override: data-URL (base64 pending evrak) uzantısız olduğundan tür dışarıdan verilir; `label` alt etiketi ezer.
 */
export function DocChip({ url, onOpen, onRemove, busy, isPdf: isPdfProp, label, size = 116 }: { url: string; onOpen?: (url: string) => void; onRemove?: () => void; busy?: boolean; isPdf?: boolean; label?: string; size?: number }) {
  /**
   * TÜR — küçük resim neyi çizecek. Excel/Word görsel DEĞİLDİR: `<img>` ile çizilirse
   * KIRIK GÖRSEL çıkar ve etiket "Görsel" der (28 Ağu 2026 tarayıcı kontrolünde yakalandı).
   * Önizleme modalıyla aynı uzantı ailesine bakar — ikisi ayrışırsa çip bir şey, modal
   * başka bir şey iddia eder.
   *
   * UZANTI, `isPdf` PROP'UNU YENER. Çağıranların çoğu `isPdf={kind === "document"}` geçiyor
   * (sipariş eki, personel evrakı, proje görevi) — yani "görsel değil" demek istiyor, "PDF"
   * değil. Prop'a öncelik verilince xlsx eki "PDF Belgesi" olarak görünüyordu (29 Ağu 2026
   * tarayıcı kontrolünde yakalandı). Bu yüzden uzantı ÇÖZÜLEBİLİYORSA tür ondan gelir; prop
   * yalnız uzantısız data-URL'lerde (kendi amacı) devreye girer.
   */
  const ext = (url.split("?")[0]?.split(".").pop() ?? "").toLowerCase();
  const BILINEN = ["pdf", "xlsx", "xls", "csv", "docx", "doc"];
  const uzantiVar = BILINEN.includes(ext);
  const isPdf = uzantiVar ? ext === "pdf" : (isPdfProp ?? false);
  const isSheet = uzantiVar && ["xlsx", "xls", "csv"].includes(ext);
  const isWord = uzantiVar && ["docx", "doc"].includes(ext);
  const gorselMi = !isPdf && !isSheet && !isWord;
  const imgH = Math.round(size * 0.793); // 116 → 92 (oran korunur, ufak thumbnail'lerde de tutarlı)
  return (
    <div
      style={{
        position: "relative", width: size, borderRadius: "var(--radius-md)", overflow: "hidden",
        border: "1px solid var(--neutral-200)", background: "var(--white)",
        boxShadow: "0 1px 2px rgba(15,23,42,0.06)", cursor: onOpen ? "zoom-in" : "default",
        transition: "box-shadow 150ms, border-color 150ms",
      }}
      onMouseEnter={(e) => { if (onOpen) { e.currentTarget.style.boxShadow = "0 4px 12px rgba(15,23,42,0.14)"; e.currentTarget.style.borderColor = "var(--primary)"; } }}
      onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 1px 2px rgba(15,23,42,0.06)"; e.currentTarget.style.borderColor = "var(--neutral-200)"; }}
    >
      <button
        type="button"
        onClick={() => onOpen?.(url)}
        aria-label="Evrakı büyüt"
        disabled={!onOpen}
        style={{ display: "block", width: "100%", border: 0, padding: 0, background: "transparent", cursor: onOpen ? "zoom-in" : "default" }}
      >
        <div style={{ width: "100%", height: imgH, display: "flex", alignItems: "center", justifyContent: "center", background: gorselMi ? "var(--neutral-100)" : "var(--neutral-50)" }}>
          {isPdf ? (
            <span style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4, color: "var(--danger)" }}><Icon name="fileText" size={30} /><span style={{ fontSize: 10, fontWeight: 700, color: "var(--danger)", letterSpacing: "0.04em" }}>PDF</span></span>
          ) : isSheet ? (
            <span style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4, color: "var(--success)" }}><Icon name="table" size={30} /><span style={{ fontSize: 10, fontWeight: 700, color: "var(--success)", letterSpacing: "0.04em" }}>{ext.toUpperCase()}</span></span>
          ) : isWord ? (
            <span style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4, color: "var(--info)" }}><Icon name="fileText" size={30} /><span style={{ fontSize: 10, fontWeight: 700, color: "var(--info)", letterSpacing: "0.04em" }}>{ext.toUpperCase()}</span></span>
          ) : (
            <img src={url} alt="Evrak" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
          )}
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "5px 8px", borderTop: "1px solid var(--neutral-100)" }}>
          <span style={{ fontSize: 10.5, fontWeight: 600, color: "var(--neutral-600)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label ?? (isPdf ? "PDF Belgesi" : isSheet ? "Tablo" : isWord ? "Word Belgesi" : "Görsel")}</span>
          {onOpen ? <Icon name="eye" size={13} /> : null}
        </div>
      </button>
      {onRemove ? (
        <button
          type="button" aria-label="Evrakı kaldır" onClick={onRemove} disabled={busy}
          style={{ position: "absolute", top: 4, right: 4, width: 20, height: 20, borderRadius: "50%", border: 0, background: "rgba(15,23,42,0.7)", color: "#fff", cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center", padding: 0 }}
        >
          <Icon name="x" size={12} />
        </button>
      ) : null}
    </div>
  );
}
